/**
 * A linear progress bar component that can be interactive.
 * @param {Object} props - The component props
 * @param {number} [props.width=300] - The width of the progress bar in pixels
 * @param {number} [props.height=5] - The height of the progress bar in pixels
 * @param {number} props.value - The current value of the progress bar
 * @param {Function} [props.setValue] - Optional callback function to update the value when clicked
 * @param {number} [props.outOf=100] - The maximum value of the progress bar
 * @returns {JSX.Element} A linear progress bar that changes color based on progress and can be interactive if setValue is provided
 */
export default function LinearProgress({
  width = 300,
  height = 5,
  value,
  setValue,
  outOf = 100,
  className = "",
  style={}
}) {
  const v = (width / outOf) * value;

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const newValue = Math.round((clickX / width) * outOf);
    setValue(newValue);
  };

  const hue = Math.round((value / outOf) * 120);
  const backgroundColor = `hsl(${hue}, 100%, 40%)`;

  return (
    <div
      className={"bg-gray-400 rounded " + className}
      style={{ width, height, cursor: setValue ? "pointer" : "arrow", ...style }}
      onClick={handleClick}
  
    >
      <div
        className="rounded transition-all duration-300 ease-in-out"
        style={{ width: v, height, backgroundColor }}
      ></div>
    </div>
  );
}
